<div class="global-time-settings-container" [class.is-collapsed]="isCollapsed" data-test-id="global-time-settings-container">
  <div class="header" (click)="toggleCollapse()" data-test-id="global-time-settings-toggle">
    <div class="header-left">
      <mat-icon class="settings-icon">schedule</mat-icon>
      <span class="title">{{ 'app.globalTimeSettings' | translate }}</span>
      @if (isCollapsed) {
        <span class="subtitle">
          <mat-icon class="chip-icon">date_range</mat-icon>
          {{ currentDateRangeLabel }}
          <span class="subtitle-separator">·</span>
          <mat-icon class="chip-icon">blur_on</mat-icon>
          {{ currentSmoothingLabel }}
        </span>
      }
    </div>
    <button
      mat-icon-button
      type="button"
      class="collapse-button"
      [attr.aria-label]="isCollapsed ? ('app.expand' | translate) : ('app.collapse' | translate)"
      >
      <mat-icon class="collapse-icon">{{ isCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
    </button>
  </div>

  @if (!isCollapsed) {
    <div class="settings-content">
      <form [formGroup]="settingsForm" class="settings-form">
        <div class="settings-fields">
          <!-- Date Range Dropdown -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="field field--range"
            >
            <mat-label>{{ 'app.displayTimePeriod' | translate }}</mat-label>
            <mat-icon matPrefix>date_range</mat-icon>
            <mat-select
              [formControl]="dateRangeControl"
              (selectionChange)="onDateRangeChange($event)"
              data-test-id="global-date-range-select"
              >
              @for (option of dateRangeOptions; track option) {
                <mat-option
                  [value]="option.value"
                  >
                  {{ option.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Custom Date Range Picker -->
          @if (showCustomDateRange) {
            <mat-form-field
              [color]="'accent'"
              appearance="outline"
              subscriptSizing="dynamic"
              class="field field--custom"
              >
              <mat-label>{{ 'app.filterTimePeriod' | translate }}</mat-label>
              <mat-icon matPrefix>event</mat-icon>
              <mat-date-range-input
                [formGroup]="settingsForm"
                [rangePicker]="globalDatepicker"
                data-test-id="global-custom-date-range"
                >
                <input
                  matStartDate
                  type="text"
                  matInput
                  formControlName="filterDateStart"
                  placeholder="dd.mm.yyyy"
                  data-test-id="global-custom-date-start"
                  />
                <input
                  matEndDate
                  type="text"
                  matInput
                  formControlName="filterDateEnd"
                  placeholder="dd.mm.yyyy"
                  data-test-id="global-custom-date-end"
                  />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matSuffix
                [for]="globalDatepicker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #globalDatepicker>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>
                    {{ 'app.close' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    color="primary"
                    matDatepickerApply
                    >
                    {{ 'app.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          }
          <!-- Smoothing Dropdown -->
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="field field--smoothing"
            >
            <mat-label>{{ 'app.smoothingTimePeriod' | translate }}</mat-label>
            <mat-icon matPrefix>blur_on</mat-icon>
            <mat-select
              [formControl]="smoothingControl"
              data-test-id="global-smoothing-select"
              >
              @for (option of smoothingOptions; track option) {
                <mat-option
                  [value]="option.value"
                  >
                  {{ option.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="apply-settings-button"
          [disabled]="!hasPendingChanges"
          (click)="applySettings()"
          data-test-id="global-time-settings-apply"
          >
          <mat-icon>check</mat-icon>
          <span>{{ 'app.applyGlobalTimeSettings' | translate }}</span>
        </button>
      </form>
    </div>
  }
</div>
